
import { connect } from 'react-redux';
import LoginComponent from '../components/LoginComponent';
import { login } from '../actions/ProfileActions';

const mapStateToProps = (state) => ({
    submitting: state.profile.submitting,
    firebasePopupOpen: state.profile.firebasePopupOpen,
});

const mapDispatchToProps = (dispatch) => ({
    login: (email, password) => {
        dispatch(login(email, password));
    },
});

const LoginContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(LoginComponent);

export default LoginContainer;
